import contents from './contents'
import contentsNxt from './contentsNxt'
import dental from './dental'
import dogLiabilityNxt from './dogLiabilityNxt'
import drone from './drone'
import householdAt from './householdAt'
import legal from './legal'
import legalUnified from './legalUnified'
import liabilityNxt from './liabilityNxt'
import petHealth from './petHealth'
import petHealthV2 from './petHealthV2'
import travelHealthNxt from './travelHealthNxt'

// [hygen-marker] import

export const flowConfigsDe: {
  contents: typeof contents
  legal: typeof legal
  legalUnified: typeof legalUnified
  dental: typeof dental
  drone: typeof drone
  liabilityNxt: typeof liabilityNxt
  dogLiabilityNxt: typeof dogLiabilityNxt
  contentsNxt: typeof contentsNxt
  petHealth: typeof petHealth
  petHealthV2: typeof petHealthV2
  travelHealthNxt: typeof travelHealthNxt
} = {
  contents,
  legal,
  legalUnified,
  dental,
  drone,
  liabilityNxt,
  dogLiabilityNxt,
  contentsNxt,
  petHealth,
  petHealthV2,
  travelHealthNxt,
}

export const flowConfigsAt = {
  householdAt,
} as const

export { getCommonFlowConfig } from './common'
